export default __webpack_public_path__ + "static/media/TF_22.40659005.png";